import React, { useContext, useEffect, useState } from "react";
import useScript from "../hooks/useScript";
import { ThemeContext } from "../context/ThemeContext";
import SavedCard from "./SavedCard";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { Environment } from "../utils/environments";
import { useNavigate, useSearchParams } from "react-router-dom";
import exponentialBackoff from "../utils/exponentialBackoff";
import PayJpCardView from "./PayJpCardView";
import PayjpBottom from "./PayjpBottom";
import { setAvailableCardList } from "../utils/payjpUtlis";
import { UserDataContext } from "../context/UserDataContext";
import { isDateFromFuture } from "../lib/dateCalculate";
import { setAnalyticsData } from "../utils/firebaseLog";
import CouponSelectModal from "./CouponSelectModal";
import { cardNameValid } from "../lib/validation";
import PaymentProcessingModal from "./PaymentProcessingModal";

declare var Payjp: any;
function PayJp({
  chargeData,
  state,
  productId,
  couponData,
  buyType,
  setCoupon,
  concernText,
  concernTextError,
  setConcernTextError,
  productInfo,
  deviceSelect,
  remoteSupport,
}) {
  const { getCouponData, setCouponData, userData, setUserData } =
    useContext(UserDataContext);
  const { payjpData, getPurchaseList } = useContext(ThemeContext);
  const [searchParams] = useSearchParams();
  const [buttonClickable, setButtonClickable] = useState<boolean>(false);
  const [inputEvents, setInputEvents] = useState<any>([]);
  const [cardName, setCardName] = useState<string | undefined>();
  const [saveCard, setSaveCard] = useState<boolean>(false);
  const [useSavedCard, setUseSavedCard] = useState<boolean>(true);
  const [cvvDigits, setCvvDigits] = useState<number>(3);
  const [getPayjpData, setPayjpData] = payjpData;
  const [availableCard, setAvailableCards] = useState<any>();
  const [error, setError] = useState<any>(undefined);
  const [cardNumberError, setCardNumberError] = useState<boolean>(false);
  const [cardExpiryError, setCardExpiryError] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [cardCvcError, setCardCvcError] = useState<boolean>(false);
  const [showProcessingModal, setShowProcessingModal] =
    useState<boolean>(false);
  const [cardNameError, setCardNameError] = useState<boolean>(false);
  const [showCouponSelectModal, setShowCouponSelectModal] =
    useState<boolean>(false);
  const [tokenId, setTokenId] = useState<string>("");
  const [purchaseList, setPurchaseList] = getPurchaseList;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const parentTicketNumber =
    searchParams.get("parentTicketNumber") ||
    sessionStorage.getItem("parentTicketNumber") ||
    "";
  const reservationTimeParam =
    searchParams.get("reservationTime") ||
    sessionStorage.getItem("reservationTime") ||
    undefined;
  const supportTypeParam =
    searchParams.get("supportType") ||
    sessionStorage.getItem("supportType") ||
    undefined;
  const reserveNowParam =
    searchParams.get("reserveNow") ||
    sessionStorage.getItem("reserveNow") ||
    false;
  const staffIdParam =
    searchParams.get("staffId") || sessionStorage.getItem("staffId") || false;
  const loadPayJp = useScript(`https://js.pay.jp/v2/`, {
    removeOnUnmount: true,
  });
  useEffect(() => {
    let params: any = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    console.log(params);
    if (reserveNowParam) {
      const checkParams = checkReserveNowParams();
      console.log(checkParams);
      if (!checkParams) {
        navigate("/error?code=404");
      }
    }
  }, [reserveNowParam]);
  function checkReserveNowParams() {
    const regex = /^SUPPORT-(\d{8})-(\d{2})-(\d{2})$/;

    if (
      !productId ||
      !reservationTimeParam ||
      !supportTypeParam ||
      !staffIdParam
    ) {
      return false;
    }

    const match = reservationTimeParam.match(regex);
    if (!match) {
      return false;
    }

    const [_, ymd, hh, mm] = match;
    if (!isDateFromFuture(`${ymd}${hh}${mm}`)) {
      return false;
    }

    return ["ONLINE", "TEL"].includes(supportTypeParam);
  }

  useEffect(() => {
    document.title = "決済";
    if (!document.querySelector("#v2-mdc-card-number")) {
      return;
    }
    payjpfunc();
    if (Environment.getBuildType() != "prod") {
      console.log(chargeData);
    }
  }, [document.querySelector("#v2-mdc-card-number"), loadPayJp == "ready"]);
  useEffect(() => {
    if (useSavedCard === false) {
      payjpfunc();
    }
  }, [useSavedCard]);
  useEffect(() => {
    disableButton();
    changeCVV();
  }, [cardName, inputEvents, cardNameError]);
  useEffect(() => {
    if (inputEvents[0] && inputEvents[0].cardBrand && availableCard) {
      checkIfCardAcceptable();
    }
  }, [inputEvents[0] && inputEvents[0].cardBrand, availableCard]);

  useEffect(() => {
    if (chargeData) {
      if (chargeData.creditcard.cardId && useSavedCard) {
        setButtonClickable(true);
      }
      const cardListImages = setAvailableCardList(chargeData);
      setAvailableCards(cardListImages);
    }
  }, [chargeData]);
  function checkIfCardAcceptable() {
    if (availableCard.cardNames.includes(inputEvents[0].cardBrand)) {
    }
  }
  function payjpfunc() {
    var buttonElm: any = document.querySelector(".mdc-text-field");
    if (loadPayJp !== "ready") return;

    try {
      const payjp = getPayjpData?.payjp?._apiKey
        ? getPayjpData.payjp
        : Payjp(Environment.getPayjpId(), {
            threeDSecureWorkflow: "redirect",
          });
      console.log(payjp);
      var elements = payjp.elements();
      console.log(elements);
      setButtonClickable(false);
      var elementStyle = {
        base: {
          "::placeholder": {
            color: "#D9D9D9",
            fontWeight: "600",
            fontSize: "16px",
          },
          lineHeight: "28px",
          height: "auto",
        },
        invalid: {
          color: "rgba(0, 0, 0, 0.87)",
        },
      };
      var numberElement = elements.create("cardNumber", {
        style: elementStyle,
        placeholder: "1234 1234 1234 1234",
      });
      var expiryElement = elements.create("cardExpiry", {
        style: elementStyle,
        placeholder: "MM（月） / YY（年）",
      });
      var cvcElement = elements.create("cardCvc", {
        style: elementStyle,
        placeholder: "000",
      });
      Promise.resolve([numberElement, expiryElement, cvcElement]).then(() => {
        numberElement.mount("#v2-mdc-card-number");
        expiryElement.mount("#v2-mdc-card-expiry");
        cvcElement.mount("#v2-mdc-card-cvc");
      });
      var payjpElements = [numberElement, expiryElement, cvcElement];
      var nameInput: any = document.querySelector("#v2-mdc-name");

      // 入力値のバリデーション結果を表示
      var changes = {};
      payjpElements.forEach(function (element, idx) {
        changes[idx] = null;
        element.on("change", function (event) {
          changes[idx] = event;
          handleInput(event);
          buttonElm.setAttribute("disabled", "true");
        });
      });
      setPayjpData({
        changes: changes,
        payjp: payjp,
        nameInput: nameInput,
        payjpElements: payjpElements,
      });
    } catch (err) {
      if (Environment.getBuildType() != "prod") {
        console.log(err);
      }
    }
  }

  function handleInput(event: any) {
    const {
      elementType,
      complete: eventComplete,
      error: eventError,
      brand: cardBrand,
    } = event;
    setInputEvents((oldData: any[]) => {
      const updatedData = oldData.map((data) =>
        data.elementType === elementType
          ? { ...data, eventComplete, eventError, cardBrand }
          : data
      );

      const isAlreadyInArray = updatedData.some(
        (data) => data.elementType === elementType
      );

      return isAlreadyInArray
        ? updatedData
        : [
            ...updatedData,
            { elementType, eventComplete, eventError, cardBrand },
          ];
    });

    setButtonClickable(eventComplete);
    showCardWarning(elementType, eventError);
    console.log(eventError);
    setCardNumberError(elementType === "cardNumber" && !!eventError);
    setCardExpiryError(elementType === "cardExpiry" && !!eventError);
    setCardCvcError(elementType === "cardCvc" && !!eventError);
  }

  function showCardWarning(element: string, err: object) {
    const inputSelectors: Record<string, string> = {
      cardNumber: "#v2-mdc-card-number",
      cardExpiry: "#v2-mdc-card-expiry",
      cardCvc: "#v2-mdc-card-cvc",
    };

    if (err) setButtonClickable(false);

    Object.entries(inputSelectors).forEach(([key, selector]) => {
      const input = document.querySelector(selector);
      input?.classList.toggle("input-err", key === element && !!err);
    });
  }
  function disableButton() {
    const allInputsComplete =
      inputEvents.length === 3 &&
      inputEvents.every((event) => event.eventComplete === true);

    const isButtonEnabled = cardName && !cardNameError && allInputsComplete;

    setButtonClickable(isButtonEnabled === true ? true : false);
  }
  function changeCVV() {
    const isAmex =
      inputEvents.length > 0 && inputEvents[0].cardBrand === "American Express";
    setCvvDigits(isAmex ? 4 : 3);
  }
  function validateCardName(name: string) {
    const isValid = cardNameValid(name);
    setCardName(name);
    setCardNameError(!isValid);
  }
  function validateCardNameOnChange(name: string) {
    const isValid = cardNameValid(name);
    setCardNameError(false);
    setCardName(isValid ? name : undefined);
  }

  function handlePayjp(e: any, usePayjp: boolean) {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    if (cardNameError) {
      setLoading(false);
      return;
    }
    setError(false);
    setErrorModal(false);
    setConcernTextError(false);

    if (concernText.length > 500) {
      setError("500文字以内で入力してください。");
      setErrorModal(true);
      setLoading(false);
      setConcernTextError(true);
      return;
    }
    if (useSavedCard && chargeData.creditcard.cardId != "") {
      usePayjp = false;
    }

    if (usePayjp) {
      const { changes, payjp, nameInput, payjpElements } = getPayjpData || {};
      const isChangesComplete = Object.keys(changes || {})
        .sort()
        .every((key) => changes[key]?.complete);

      if (!isChangesComplete) return;

      const cardInfo: any = {
        name: nameInput.value || undefined,
        email: userData?.email || undefined,
      };
      var options = {
        three_d_secure: true,
        card: cardInfo,
      };
      console.log("ss");
      payjp.createToken(payjpElements[0], options).then((result: any) => {
        if (result.id) {
          setTokenId(result.id);
          console.log(result.id);
          checkIfCouponSelected(result.id);
        } else {
          if (Environment.getBuildType() != "prod") {
            console.log(result);
          }
          setError(result.error.message);
          setErrorModal(true);
          setLoading(false);
        }
      });
    } else {
      checkIfCouponSelected("");
    }
  }

  useEffect(() => {
    if (sessionStorage.getItem("token") && chargeData) {
      completeTds(sessionStorage.getItem("token") || "");
      setShowProcessingModal(true);
    }
    console.log("sadasdas");
  }, [chargeData]);

  async function completeTds(token: string) {
    try {
      const response = await httpPost({
        pathName: "tdsFinish",
        bodyParams: {
          tokenId: token,
        },
      });
      console.log(response);
      if (response.status === 200 && response.data.data.id) {
        submitData(token);
        sessionStorage.removeItem("token");
      }
    } catch (error) {
      setShowProcessingModal(false);
      setError(
        "決済に問題がありました。\nカード情報を確認後再度ご購入ください"
      );
      setErrorModal(true);
      setLoading(false);
      sessionStorage.clear();
      console.error("Error completing the 3DS flow:", error);
    }
  }
  useEffect(() => {
    const handlePopState = () => {
      if (sessionStorage.getItem("token") && chargeData) {
        completeTds(sessionStorage.getItem("token") || "");
        setShowProcessingModal(true);
      }
    };

    window.addEventListener("visibilitychange", handlePopState);

    return () => {
      window.removeEventListener("visibilitychange", handlePopState);
    };
  }, []);

  const handleRedirect = async (token: string) => {
    const publicKey = Environment.getPayjpId();
    let params: any = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    sessionStorage.setItem("params", JSON.stringify(params));
    sessionStorage.setItem(
      "paramsForSubmit",
      JSON.stringify(getParamsForSubmit(token))
    );
    sessionStorage.setItem("parentTicketNumber", parentTicketNumber);
    reserveNowParam && sessionStorage.setItem("reserveNow", reserveNowParam);
    supportTypeParam && sessionStorage.setItem("supportType", supportTypeParam);
    staffIdParam && sessionStorage.setItem("staffId", staffIdParam);
    reservationTimeParam &&
      sessionStorage.setItem("reservationTime", reservationTimeParam);
    couponData && sessionStorage.setItem("couponCode", couponData.couponCode);
    sessionStorage.setItem("state", JSON.stringify(state));
    sessionStorage.setItem("productId", productId);
    sessionStorage.setItem("concernText", concernText);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("buyType", buyType);
    if (useSavedCard && chargeData.creditcard.cardId != "") {
      submitData(token);
      return;
    }
    window.location.href = `https://api.pay.jp/v1/tds/${token}/start?publickey=${publicKey}&back=${
      window.location.href.includes("localhost:")
        ? "test3DsecureRedirectBuy"
        : Environment.getPayjpRedirectUrl()
    }`;
  };

  const getParamsForSubmit = (id: string) => {
    var productData = chargeData.product;
    const reservationTime = reserveNowParam
      ? reservationTimeParam
      : ["INTERVIEW", "TIP", "ADD"].includes(productData.productType)
      ? productData.productType
      : `${productData.productType}-${state.date}-${state.time}`;

    var menuItems: any = [];
    const menuItem = reserveNowParam
      ? {
          menuId: productId,
          estimatedMinute: productData.minutesToSupport,
          menuTitle: productData.productName,
        }
      : state?.ticket
      ? {
          menuId: productId,
          estimatedMinute: state.ticket.minutesToSupport,
          menuTitle: state.ticket.productName,
        }
      : null;

    if (menuItem) menuItems.push(menuItem);
    var couponCode =
      couponData && couponData.data.couponAvailable
        ? couponData.couponCode
        : "";
    const supportType = reserveNowParam ? supportTypeParam : buyType;
    const staffId = staffIdParam || state?.staffInfo?.staffId || "";
    return {
      productId: productId,
      cardId: useSavedCard ? chargeData.creditcard.cardId : "",
      cardToken: id,
      saveCard: !!saveCard,
      parentTicketNumber,
      staffId,
      couponCode,
      reservationTime,
      reservationMenuList: menuItems,
      supportType,
      reserveNow: reserveNowParam,
      counsellingComment: concernText,
      contactDevice: deviceSelect.device,
      contactOs: deviceSelect.os,
      remoteSupport,
    };
  };

  async function submitData(id: string) {
    const params = JSON.parse(
      sessionStorage.getItem("paramsForSubmit") || "{}"
    );
    if (Environment.getBuildType() != "prod") {
      console.log(params);
    }
    const request = async () =>
      httpPost({
        pathName: "charge",
        bodyParams: params,
      }).then((response: AxiosResponse<any>) => {
        if (Environment.getBuildType() != "prod") {
          console.log(response.data);
        }
        if (response.status == 200) {
          getBuyType(chargeData?.product.productType);
          setPurchaseList(undefined);
          setUserData(undefined);
          navigate(`/buy-complete?type=${chargeData?.product.productType}`, {
            state: { couponCode: params.couponCode },
          });
        }
      });
    try {
      await exponentialBackoff(request);
    } catch (error) {
      setShowProcessingModal(false);
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error?.response?.status >= 400 && error?.response?.status <= 499) {
        if (
          error?.response?.data?.message.includes("STAFF_ASSING_DENY") ||
          error?.response?.data?.message.includes("STAFF_DENY")
        ) {
          if (!reserveNowParam) {
            navigate(`/support/staff?productId=${productId}`, {
              state: { displayToast: true, ...state },
            });
          } else {
            let ticket = {
              productType: supportTypeParam,
              minutesToSupport: chargeData.product.minutesToSupport,
              productName: chargeData.product.productName,
              productId: productId,
            };
            console.log(ticket);
            navigate(`/support/staff?productId=${productId}`, {
              state: { displayToast: true, ticket },
            });
          }
        }
      } else if (
        error?.response?.status >= 400 &&
        error?.response?.status <= 499 &&
        error?.response?.data?.message.includes("DENY_COUPON")
      ) {
        setError("クーポンが適用できません");
        setErrorModal(true);
        let newCouponData = getCouponData.couponList.filter((code) => {
          return code.couponCode != params.couponCode;
        });
        let obj = {
          couponList: newCouponData,
        };
        setCoupon(undefined);
        setCouponData(obj);
      } else {
        if (Environment.getBuildType() != "prod") {
          console.log(error);
        }
        setError(
          "決済に問題がありました。\nカード情報を確認後再度ご購入ください"
        );
        setErrorModal(true);
      }
    } finally {
      setLoading(false);
      setShowCouponSelectModal(false);
      sessionStorage.clear();
    }
  }
  function checkIfCouponExistsOnSelectedTicket() {
    return getCouponData.couponList.some((item) => {
      return item.availableProductList.some((product) => {
        if (
          product.productType == "SUPPORT" &&
          chargeData.product.productType == "SUPPORT"
        ) {
          return (
            product.minutesToSupport == chargeData.product.minutesToSupport
          );
        }
        return product.productType === chargeData.product.productType;
      });
    });
  }
  function checkIfCouponSelected(id) {
    if (
      chargeData &&
      getCouponData &&
      getCouponData.couponList?.length &&
      checkIfCouponExistsOnSelectedTicket() &&
      (couponData === undefined || couponData?.data.couponAvailable === false)
    ) {
      setShowCouponSelectModal(true);
    } else {
      handleRedirect(id);
    }
  }
  const handleUseCoupon = () => {
    setLoading(false);
    setShowCouponSelectModal(false);
    document
      ?.getElementById("coupon-section")
      ?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  };

  const handleDontUseCoupon = () => {
    setShowCouponSelectModal(false);
    handleRedirect(tokenId);
  };
  const handleCouponClose = () => {
    setLoading(false);
    setShowCouponSelectModal(false);
  };
  function getBuyType(buyType) {
    var eventName = "";
    if (buyType == "INTERVIEW") {
      eventName = "buyInterviewTicket";
    } else if (buyType == "ADD") {
      eventName = "buyAddTicket";
    } else if (buyType == "TIP") {
      eventName = "buyTip";
    } else if (buyType == "SUPPORT") {
      eventName = "buySupportTicket";
    }
    if (eventName == "buyTip") {
      setAnalyticsData({
        eventName: eventName,
        params: { price: chargeData?.product.price },
      });
    } else {
      setAnalyticsData({ eventName: eventName });
    }
  }
  return (
    <>
      {chargeData &&
      chargeData.creditcard &&
      chargeData.creditcard.cardId != "" &&
      useSavedCard ? (
        <SavedCard chargeData={chargeData} setUseSavedCard={setUseSavedCard} />
      ) : (
        <PayJpCardView
          cardNumberError={cardNumberError}
          availableCard={availableCard}
          cardExpiryError={cardExpiryError}
          cardCvcError={cardCvcError}
          cvvDigits={cvvDigits}
          setSaveCard={setSaveCard}
          chargeData={chargeData}
          setUseSavedCard={setUseSavedCard}
          setButtonClickable={setButtonClickable}
          cardNameError={cardNameError}
          validateCardName={validateCardName}
          validateCardNameOnChange={validateCardNameOnChange}
          email={userData?.email}
        />
      )}
      <PayjpBottom
        loading={loading}
        handlePayjp={handlePayjp}
        buttonClickable={buttonClickable}
        errorModal={errorModal}
        error={error}
        setErrorModal={setErrorModal}
        productType={chargeData?.product.productType}
        reserveNowParam={reserveNowParam}
        concernTextError={concernTextError}
        productId={productId}
        productInfo={productInfo}
      />
      {showCouponSelectModal && (
        <CouponSelectModal
          openModal={showCouponSelectModal}
          setOpenModal={setShowCouponSelectModal}
          handleUseCoupon={handleUseCoupon}
          handleDontUseCoupon={handleDontUseCoupon}
          handleCouponClose={handleCouponClose}
        />
      )}
      {showProcessingModal && <PaymentProcessingModal />}
    </>
  );
}

export default PayJp;
